import { render, staticRenderFns } from "./LocationsManagement.vue?vue&type=template&id=6fbda2fc&"
import script from "./LocationsManagement.vue?vue&type=script&lang=js&"
export * from "./LocationsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports